import analyticsModule from '@/HostApp/services/Analytics/AnalyticsModule';
import { ANALYTICS_TYPES } from '@/Common/Runtime/events';

export interface IHCContext {
	pageUrl: string;
	userId: string;
}

export enum EVENT_TYPE {
	ARTICLE_VIEWED_FROM_PAGE,
	SEARCH,
	SEARCH_RESULT_CLICKED,
	HELP_CENTER_CLOSED,
	LINK_CLICKED,
	TIME_ON_SCREEN,
	HELPFUL_ARTICLE,
	REQUEST_ARTICLE
}

const defaultPayload: Partial<Analytics.IGAEvent> = {
	event: 'help_center'
};

const eventTypeToPayloadMap: Record<EVENT_TYPE, Partial<Analytics.IGAEvent>> = {
	[EVENT_TYPE.ARTICLE_VIEWED_FROM_PAGE]: {
		eventCategory: 'help_center_viewed',
		eventAction: 'help_center_article_viewed_from_page'
	},
	[EVENT_TYPE.SEARCH]: {
		eventCategory: 'help_center_search'
	},
	[EVENT_TYPE.SEARCH_RESULT_CLICKED]: {
		eventCategory: 'help_center_viewed',
		eventAction: 'help_center_article_viewed_from_search'
	},
	[EVENT_TYPE.HELP_CENTER_CLOSED]: {
		eventCategory: 'help_center_visit_length',
		eventAction: 'help_center_visit_length'
	},
	[EVENT_TYPE.LINK_CLICKED]: {
		eventCategory: 'help_center_viewed',
		eventAction: 'help_center_article_viewed_from_help_center'
	},
	[EVENT_TYPE.TIME_ON_SCREEN]: {
		eventCategory: 'help_center_time_on_screen'
	},
	[EVENT_TYPE.HELPFUL_ARTICLE]: {
		eventCategory: 'help_center_helpful_article'
	},
	[EVENT_TYPE.REQUEST_ARTICLE]: {
		eventCategory: 'help_center_request'
	}
};

export default class HelpCenterAnalytics {
	private static sendEvent(payload: Analytics.IGAEvent): void {
		analyticsModule.pushData({
			analyticsType: ANALYTICS_TYPES.GOOGLE_ANALYTICS,
			data: payload
		});
	}

	public static buildAndSendEvent(type: EVENT_TYPE, payload: Partial<Analytics.IGAEvent>, context: IHCContext): void {
		const typePayload = eventTypeToPayloadMap[type];
		if (!typePayload) {
			return;
		}

		HelpCenterAnalytics.sendEvent({
			...defaultPayload,
			...typePayload,
			...payload,
			...context
		} as Analytics.IGAEvent);
	}
}
